import { CALL_API } from '../middleware/api'

export const POSTCARD_STORE_REQUEST = 'POSTCARD_STORE_REQUEST'
export const POSTCARD_STORE_SUCCESS = 'POSTCARD_STORE_SUCCESS'
export const POSTCARD_STORE_FAILURE = 'POSTCARD_STORE_FAILURE'

export const POSTCARD_REQUEST = 'POSTCARD_REQUEST'
export const POSTCARD_SUCCESS = 'POSTCARD_SUCCESS'
export const POSTCARD_FAILURE = 'POSTCARD_FAILURE'

export function storePostcard(creds) {
  return {
    [CALL_API]: {
      endpoint: 'postcards',
      types: [
        POSTCARD_STORE_REQUEST,
        POSTCARD_STORE_SUCCESS,
        POSTCARD_STORE_FAILURE
      ],
      config: { method: 'POST', body: creds }
    }
  }
}

export function getPostcard(link) {
  return {
    [CALL_API]: {
      endpoint: `postcards/${link}`,
      types: [
        POSTCARD_REQUEST,
        POSTCARD_SUCCESS,
        POSTCARD_FAILURE
      ],
      config: { method: 'GET'}
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/PostcardActions.js